import { render, staticRenderFns } from "./SocialShare.vue?vue&type=template&id=09f73d56&"
import script from "./SocialShare.vue?vue&type=script&lang=js&"
export * from "./SocialShare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('09f73d56')) {
      api.createRecord('09f73d56', component.options)
    } else {
      api.reload('09f73d56', component.options)
    }
    module.hot.accept("./SocialShare.vue?vue&type=template&id=09f73d56&", function () {
      api.rerender('09f73d56', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/components/SocialShare.vue"
export default component.exports